import React from 'react';

import { Stream } from '$partials/modules';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ContentPage}
 */
const ContentPage = (props) => {
    const page = props.data.page;

    return (
        <main className='container'>
            {/* Hero image */}
            {(page.heroImage || page.heroVideo) &&
                <div className='mb5 md-mb9'>
                    <div
                        className='width-100vw trunk-full-width mtn-6 sm-mtn-5 md-mtn-9'>
                        <figure>
                            {page.heroVideo ? (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={page.heroVideo.videoUrl}
                                    width={'100%'}/>
                            ) : (
                                <Image {...page.heroImage} />
                            )}
                        </figure>
                    </div>
                    {page.heroCaption && (
                        <figcaption className='col-12 md-col-8 mt4'>
                            <p className='type-style-7'>
                                {page.heroCaption}
                            </p>
                        </figcaption>
                    )}
                </div>
            }

            <div className='col-12 flex flex-wrap mb7 md-mb9'>
                <div className='col-12'>
                    <p className='type-style-5 pb5 md-pb4'>
                        {page.pageLabel}
                    </p>
                </div>
                <div className='col-12 sm-col-6 md-col-5 pb5 sm-pb0'>
                    <h1 className='type-style-1'>
                        {page.title}
                    </h1>
                </div>
                <div className='hide md-show col-1'/>
                <div className='col-12 sm-col-6 md-col-4'>
                    <div
                        className={`rich-text type-style-3${page.body ? ' pb6 sm-pb5 md-pb6' : ''}`}
                        dangerouslySetInnerHTML={{__html: page.standfirst}}/>
                    <div
                        className='rich-text content-page-body type-style-6'
                        dangerouslySetInnerHTML={{__html: page.body}}/>
                </div>
            </div>

            {/* Header links module */}
            {page.headerModules.length > 0 && (
                <div className='col-12'>
                    <Stream
                        hubspot={props.hubspot}
                        modules={page.headerModules}
                        namespace='content-page-header'
                        page={page} />
                </div>
            )}

            {/* modules */}
            <Stream
                modules={page.modules}
                namespace='content-page' />
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ContentPage ;
